import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Normalize email for lookups and uniqueness (trim + lowercase). */
export function normalizeEmail(email: string): string {
  return (email || "").trim().toLowerCase()
}

/** Convert Firestore Timestamp (object with seconds/nanoseconds), Date, or string to ISO string. Prevents React error #31 when rendering dates. */
export function toDateString(value: unknown): string {
  if (value == null) return ""
  if (typeof value === "string") return value
  if (value instanceof Date) return value.toISOString()
  const v = value as { toDate?: () => Date; seconds?: number; nanoseconds?: number }
  if (typeof v.toDate === "function") return v.toDate().toISOString()
  if (typeof v.seconds === "number") return new Date(v.seconds * 1000 + (v.nanoseconds ?? 0) / 1e6).toISOString()
  return ""
}
